import { RequestError } from 'www/vue_components/common/Analyses/components/LaboratoriesList/types'
import isNetworkDisconnect from 'www/utils/is/isNetworkDisconnect'
import dispatchCustomEventGlobally from 'www/utils/withDependences/dispatchCustomEventGlobally'

type Opts = {
  error: any
  description: string
}

export function handleRequestError(opts: Opts, attachSelector?: string) {
  const { error } = opts
  const { message, response } = error as RequestError
  const { status, data } = response || {}

  if (Array.isArray(data?.search)) {
    return
  }

  if (isNetworkDisconnect({ status, message })) {
    dispatchCustomEventGlobally('dialog:open', {
      maxWidth: 304,
      persistent: true,
      noClickAnimation: true,
      attachSelector,
      title: 'Нет интернета',
      text: 'Проверьте соединение и обновите страницу.',
      confirmText: 'Обновить',
      beforeConfirm: () => window.location.reload(),
    })

    return
  }

  dispatchCustomEventGlobally('dialog:open', {
    maxWidth: 304,
    persistent: true,
    noClickAnimation: true,
    attachSelector,
    title: 'Что-то пошло не так',
    text: 'Попробуйте немного подождать и обновите страницу.',
    confirmText: 'Обновить',
    beforeConfirm: () => window.location.reload(),
  })
}
